import React from "react";
import { Link } from "react-router-dom";
import { viewOfType } from "views/Config/Profiles/index.js"
import { CONST_TREE_RULE } from "views/Config/Rules/constants";

const ProfMenuItem = ({ type, titleEdit, returnView, dpiEnabled=false, ...other }) => (
  type === 'dpi' && dpiEnabled !== true ? null :
  <li>
    <Link to={`/${viewOfType[type]}?returnView=${returnView}`}>
      {`Manage ${titleEdit}s...`}
    </Link>
  </li>
);

const editionOfType = type => (profileName, returnView) =>
  profileName === CONST_TREE_RULE.ANY ||
  profileName === CONST_TREE_RULE.ANYOTHER
    ? undefined
    : window.globalNavigate(viewOfType[type], {edit: profileName, returnView }); 
  
export const profileEditionByType = profiles =>
  Object.fromEntries(
    profiles.map( ({type}) => [type, editionOfType(type)] )
  )

export default ProfMenuItem;
